import React from 'react';
import { Badge, Button } from 'reactstrap';
import { formatDate } from '../../utils';
import DataTable from '../DataTable';

const GmailAccountsTable = ({
  accounts,
  loading,
  onToggle,
  togglingEmail,
  onEditWhitelist,
  footer,
}) => {
  /**
   * Count the number of whitelisted senders from the array.
   */
  const whitelistCount = (arr) => {
    if (!Array.isArray(arr)) return 0;
    return arr.length;
  };

  return (
    <DataTable card={false} loading={loading} minWidth={700} footer={footer}>
      <thead className="text-primary">
        <tr>
          <th>No.</th>
          <th>Account</th>
          <th>Status</th>
          <th>Whitelisted Senders</th>
          <th>Last Synced</th>
          <th className="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        {accounts.length === 0 ? (
          <tr>
            <td colSpan="6" className="text-center py-4">
              {loading
                ? 'Fetching Gmail accounts...'
                : 'No Gmail accounts registered yet.'}
            </td>
          </tr>
        ) : (
          accounts.map((a, i) => (
            <tr key={a.account}>
              <td>{i + 1}</td>
              <td>
                <span className="font-weight-bold">{a.account}</span>
              </td>
              <td>
                <Badge
                  color={a.is_active ? 'success' : 'secondary'}
                  className="px-2 py-1"
                >
                  {a.is_active ? 'Active' : 'Inactive'}
                </Badge>
              </td>
              <td>
                <Button
                  color="default"
                  size="sm"
                  onClick={() =>
                    onEditWhitelist(a.account, a.whitelisted_senders || [])
                  }
                  title="Manage whitelisted senders"
                  style={{ textDecoration: 'underline', padding: '2px 8px' }}
                >
                  {whitelistCount(a.whitelisted_senders)} sender
                  {whitelistCount(a.whitelisted_senders) !== 1 ? 's' : ''}
                </Button>
              </td>
              <td>{a.last_synced ? formatDate(a.last_synced) : 'Never'}</td>
              <td className="text-right">
                <Button
                  color={a.is_active ? 'warning' : 'info'}
                  size="sm"
                  disabled={togglingEmail === a.account}
                  onClick={() => onToggle(a.account, !a.is_active)}
                  title={a.is_active ? 'Pause sync' : 'Resume sync'}
                >
                  {togglingEmail === a.account
                    ? 'Updating...'
                    : a.is_active
                    ? 'Pause'
                    : 'Resume'}
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </DataTable>
  );
};

export default GmailAccountsTable;
